import cx from "classnames";
import type { Location } from "history";
import { Component } from "react";
import { t } from "ttag";

import { SidebarLayout } from "metabase/common/components/SidebarLayout";
import CS from "metabase/css/core/index.css";
import { PageTitle } from "metabase/hooks/PageTitle";
import { connect } from "metabase/redux";
import * as metadataActions from "metabase/redux/metadata";
import * as actions from "metabase/reference/reference";
import SegmentDetail from "metabase/reference/segments/SegmentDetail";
import type { User } from "metabase-types/api";

import type { ClearStateProps, FetchProps } from "../reference";
import type {
  ReferenceRouteParams,
  ReferenceRouteProps,
  StateWithReference,
} from "../selectors";
import { getIsEditing, getSegment, getSegmentId, getUser } from "../selectors";
import type { StubbedSegment } from "../types";

import SegmentSidebar from "./SegmentSidebar";

const mapStateToProps = (
  state: StateWithReference,
  props: ReferenceRouteProps,
) => ({
  user: getUser(state),
  segment: getSegment(state, props),
  segmentId: getSegmentId(state, props),
  isEditing: getIsEditing(state),
});

const mapDispatchToProps = {
  ...metadataActions,
  ...actions,
};

interface SegmentDetailContainerProps extends FetchProps, ClearStateProps {
  // From React Router
  params: ReferenceRouteParams;
  location: Location;

  // From route definition / parent
  style: React.CSSProperties;

  // From mapStateToProps
  user: User | null;
  segment: StubbedSegment;
  segmentId: number;
  isEditing?: boolean;

  // From mapDispatchToProps
  fetchSegmentTable: (id: number) => Promise<unknown>;
}

class SegmentDetailContainer extends Component<SegmentDetailContainerProps> {
  fetchContainerData() {
    actions.wrappedFetchSegmentDetail(this.props, this.props.segmentId);
  }

  UNSAFE_componentWillMount() {
    this.fetchContainerData();
  }

  UNSAFE_componentWillReceiveProps(newProps: SegmentDetailContainerProps) {
    if (this.props.location.pathname === newProps.location.pathname) {
      return;
    }

    actions.clearState(newProps);
  }

  render() {
    const { user, segment, isEditing } = this.props;

    return (
      <>
        <PageTitle title={segment?.name || t`Segment`} titleIndex={1} />
        <SidebarLayout
          className={cx(CS.flexFull, CS.relative)}
          style={isEditing ? { paddingTop: "43px" } : {}}
          sidebar={<SegmentSidebar segment={segment} user={user} />}
        >
          <SegmentDetail {...this.props} />
        </SidebarLayout>
      </>
    );
  }
}

// connect HOC tangle: action-type constants in `actions` + JS-typed metadata thunks.
// eslint-disable-next-line import/no-default-export -- deprecated usage
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SegmentDetailContainer as unknown as React.ComponentType);
